import { Node, mergeAttributes } from '@tiptap/core';

// ═══════════════════════════════════════════════════════════════
// PageNumberField — token čísla stránky do záhlaví/zápatí (Fáze 2).
//
// V editoru se zobrazí jako nemazatelný „chip" (# nebo ##), v exportu se
// přeloží na docx.js PageNumber / NumberOfPages field, který Word/PDF
// vyplní reálnou hodnotou. V HTML serializaci nese data atribut, aby ho
// export a round-trip poznal:  <span data-field="page"> / data-field="pages"
// ═══════════════════════════════════════════════════════════════

export type FieldKind = 'page' | 'pages';

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    pageNumberField: {
      insertPageField: (kind: FieldKind) => ReturnType;
    };
  }
}

export const PageNumberField = Node.create({
  name: 'pageNumberField',
  inline: true,
  group: 'inline',
  atom: true,
  selectable: true,

  addAttributes() {
    return {
      kind: {
        default: 'page',
        parseHTML: (el) => el.getAttribute('data-field') || 'page',
        renderHTML: (attrs) => ({ 'data-field': attrs.kind || 'page' }),
      },
    };
  },

  parseHTML() {
    return [{ tag: 'span[data-field]' }];
  },

  renderHTML({ HTMLAttributes, node }) {
    const label = node.attrs.kind === 'pages' ? 'počet stran' : 'č. stránky';
    return [
      'span',
      mergeAttributes(HTMLAttributes, { class: 'doc-field-chip', contenteditable: 'false' }),
      label,
    ];
  },

  addCommands() {
    return {
      insertPageField:
        (kind) =>
        ({ commands }) =>
          commands.insertContent({ type: this.name, attrs: { kind } }),
    };
  },
});
